/**
 * Created by wjy on 2018-10-11
 */
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Utils from '@chehejia/club-lib/lib/utils/Utils';
import Cookie from '@util/cookie';
import QrcodeLogin from './component/qrcode';
import AccountLogin from './component/account';
import './index.scss';
import $ from 'jquery';

import {auth, IdaasLogin, getToken} from "../../util/auth";

@inject('store')
@observer
export default class Login extends React.Component<any, any> {
    // public loginNav: any = ['账号登录', '扫码登录'];
    public loginNav: any = ['扫码登录'];
    public constructor(props) {
        super(props);
        this.init();
    }
    public init() {
        this.state = {
            currentNav: 0
        };

        let deviceid = localStorage.getItem('DEVICEID');
        if (!deviceid) {
            deviceid = Utils.UUID();
            localStorage.setItem('DEVICEID', deviceid);
        }
        Cookie.set('X-LX-Deviceid', deviceid);
    }
    public hasLogin = () => {
        this.props.store.hasLoginManage(hasLogin => {
            if (hasLogin) {
                window.location.href = '/';
                // this.props.store.dataLoginIM
                //     .loginIM()
                //     .then((res) => {
                //         const val = JSON.stringify(res);
                //         sessionStorage.setItem('imUser', val);
                //         console.log('登录IM成功=====>', res);
                //     })
                //     .catch((err) => {
                //         console.log('登录IM失败=====>', err);
                //     });
            }
        });
    };
    public switchNav = index => {
        this.setState({
            currentNav: index
        });
    };
    // 设备信息上报
    public collectInfo = () => {
        if (localStorage.getItem('ldId')) {
            return;
        }
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        const Env = window['serverEnv'] || window['localEnv'];
        let url = 'https://id-ontest.lixiang.com/api/devices';
        let client_id = '6hROPDL4DrwsWCfKNdVgfq';
        if (Env === 'prod') {
            url = 'https://id.lixiang.com/api/devices';
            client_id = '4u4ctOfeAQBmzCMMpntV5g';
        }
        const liId = `${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}`;
        const screen_width = window.screen.width;
        const screen_height = window.screen.height;

        $.ajax({
            url,
            type: 'post',
            data: JSON.stringify({
                device_id: liId,
                client_id,
                screen_height,
                screen_width,
                user_agent: navigator.userAgent
            }),
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            crossDomain: true,
            contentType: 'application/json',
            success: res => {
                if (res) {
                    localStorage.setItem('ldId', liId);
                }
            },
            error: () => {
                console.log('error');
            }
        });
    };
    public async componentWillMount() {
        // const isAuthenticated = await auth.isAuthenticated();
        // console.log('判断登录状态成功===>', isAuthenticated);
        // if (!isAuthenticated) {
        //   IdaasLogin();
        // } else {
        //   const userInfo = await auth.getUser();
        //   getToken()
        //   console.log("🎉恭喜你，登录成功", userInfo);
        //   this.hasLogin();
        // }

        // let deviceid = localStorage.getItem('DEVICEID');
        // if (!deviceid) {
        //     deviceid = Utils.UUID();
        //     localStorage.setItem('DEVICEID', deviceid);
        // }
        // Cookie.set('X-LX-Deviceid', deviceid);
        this.collectInfo();
        this.hasLogin();
    }
    public componentDidMount() {
        document.title = '理想社群文章发布平台';
    }
    public render() {
        const { route, history } = this.props;
        const { dataLogCodeModel } = this.props.store;
        const { currentNav } = this.state;
        console.log(route, history);
        return (
            <div className="loginWrap">
                <div className="loginHeader">
                    <div className="headerBox">
                        <div className="loginLogo">
                            <img
                                src={require('../../assets/images/commonImg/lixiang_logo_white.png')}
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <div className="loginBox">
                    <div className="login-nav">
                        <ul>
                            {this.loginNav.map((item, idx) => {
                                // tslint:disable-next-line: jsx-no-lambda
                                return (
                                    <li
                                        onClick={() => this.switchNav(idx)}
                                        className={
                                            currentNav === idx ? 'active' : ''
                                        }
                                        key={idx}>
                                        {item}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    {/* {currentNav === 0 ? <AccountLogin hasLogin={this.hasLogin} /> : <QrcodeLogin hasLogin={this.hasLogin} />} */}
                    {currentNav === 1 ? (
                        <AccountLogin hasLogin={this.hasLogin} />
                    ) : (
                        <QrcodeLogin hasLogin={this.hasLogin} />
                    )}
                </div>
                <div className="loginBottom">
                    <p>
                        京公网安备11011502002791号 ©2019 理想 版权所有
                        京ICP备15059201号-1{' '}
                    </p>
                </div>
            </div>
        );
    }
}
